import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import { searchIconDark } from '../../media/icons';

import Widget, { WidgetContent } from './Widget';
import Input from '../forms/Input';
class CarPartsSearchWidget extends Component {
  state = {
    search: ''
  };

  componentDidMount() {
    const query = qs.parse(this.props.location.search, {
      arrayFormat: 'bracket'
    });

    this.setState({
      search: query.sok || ''
    });
  }

  handleChange = event => {
    this.setState({
      search: event.target.value
    });
  };

  onSearchSumbit = event => {
    event.preventDefault();

    const query = qs.parse(this.props.location.search, {
      arrayFormat: 'bracket'
    });

    return this.props.history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          sok: this.state.search || undefined
        },
        { arrayFormat: 'bracket' }
      )
    });
  };

  render() {
    return (
      <Widget>
        <WidgetContent>
          <form onSubmit={this.onSearchSumbit}>
            <Input
              id="searchelement"
              name="carPartSearch"
              label="Søk etter bildeler"
              hideLabel={true}
              value={this.state.search}
              placeholder="Søk i fritekst…"
              icon={searchIconDark}
              onChange={this.handleChange}
            />
          </form>
        </WidgetContent>
      </Widget>
    );
  }
  x;
}

export default withRouter(CarPartsSearchWidget);
